module.exports = __webpack_public_path__ + "166966f85797168352b8f94cbcf7f036.png";